import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AppService } from '@app/app.service';
import { EmitService } from '@app/ts/services/emit.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CommonService } from '../services/common.service';

@Injectable()
export class AuthGuard implements CanActivate {
  accounts_url: any;
  constructor(private router: Router,private appService : AppService,private commonservice:CommonService,private http: HttpClient,private emitService: EmitService) {
    this.apiUrl = localStorage.getEncryptedItem('API_END_POINT_ACCOUNTS');
    this.accounts_url = localStorage.getEncryptedItem('ACCOUNTS_URL');
  }
  routerPermission: any;
  apiUrl = '';
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const cookieExist = this.commonservice.getCookie(environment.checkCookie);
    
    if (!cookieExist) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    const expiredCookie = this.commonservice.decrypt(decodeURIComponent(cookieExist));
    const domain = localStorage.getEncryptedItem('domain');
    const formData = new FormData();
    formData.append("domain", `.${domain}`);

    if (this.tokenExpired(expiredCookie)) {
      this.appService.createAccessToken(formData).subscribe(); // token refresh
    }

    const userData = this.getUserData();
    if (!userData?.[0]?.isSubscriptionFound) {
      this.fetchAndStoreUserProfile(route);
      return false;
    }

    return this.checkPermissionAndContinue(route);
  }

  // 🔹 Extracted helper methods to reduce complexity:

  private getUserData(): any[] | null {
    const userDataRaw = localStorage.getEncryptedItem('userData');
    return userDataRaw ? JSON.parse(userDataRaw) : null;
  }

  private fetchAndStoreUserProfile(route: ActivatedRouteSnapshot): void {
    const formData = new FormData();
    formData.append('code', 'EDI');
    const token = this.commonservice.createToken(this.commonservice.createObject(formData));
    const encryptedToken = this.commonservice.encrypt(token);

    const encrData = new FormData();
    encrData.append("encrToken", encryptedToken);

    const tempPath = this.getPathFromHash();

    this.http.post(`${this.apiUrl}users/user-profile`, encrData).subscribe(dataFromApi => {
      const user = dataFromApi['data'];
      this.saveUserProfileToLocalStorage(user);
      this.setCookies(user);

      const permissionCookie = this.commonservice.getCookie(environment.permissions);
      if (!this.hasRequiredPermission(permissionCookie, route.data.right)) {
        window.location.href = `${this.accounts_url}auth/logout/`;
        return;
      }

      if (!user[0].isSubscriptionFound) {
        window.location.href = `${localStorage.getEncryptedItem('BILLING_URL')}user-plans`;
        return;
      }

      setTimeout(() => {
        const language = user[0].language || 'de';
        this.emitService.emitUserLanguageChange(language);
      }, 100);

      window.location.href = `${this.accounts_url}${tempPath}`;
    });
  }

  private saveUserProfileToLocalStorage(user: any[]): void {
    const company = user[0].companyDetails.find(item => item.partyid == localStorage.getEncryptedItem('partyID'));
    const userInfo = {
      userName: user[0].username,
      companyName: company?.companyname || ''
    };
    this.commonservice.setCookie(
      this.commonservice.encrypt(environment.userInfo),
      this.commonservice.encrypt(JSON.stringify(userInfo)),
      10000,
      environment.cookieDomain,
      '/'
    );

    const permissions = String(user[0].permissions.Allow);
    this.commonservice.setCookie(environment.permissions, this.commonservice.encrypt(permissions), 10000, environment.cookieDomain, '/');

    localStorage.setEncryptedItem('userData', JSON.stringify(user));
    localStorage.setEncryptedItem('accId', user[0].accId);
    localStorage.setEncryptedItem('isCompanyConfirmed', user[0].isConfirmedParty.toString());
    localStorage.setEncryptedItem('isAddressEmpty', user[0].isAddressEmpty.toString());
    localStorage.setEncryptedItem('hasPermission', user[0].hasPermission.toString());
    localStorage.setEncryptedItem('hideTutorial', user[0].hidetutorial.toString());
  }

  private hasRequiredPermission(permissionCookie: string, requiredRight: string): boolean {
    const decrypted = this.commonservice.decrypt(decodeURIComponent(permissionCookie));
    return decrypted.includes(requiredRight);
  }

  private checkPermissionAndContinue(route: ActivatedRouteSnapshot): boolean {
    const permissionCookie = this.commonservice.getCookie(environment.permissions);
    if (!this.hasRequiredPermission(permissionCookie, route.data.right)) {
      window.location.href = `${this.accounts_url}auth/logout/`;
      return false;
    }
    return true;
  }

  private getPathFromHash(): string {
    const hashPath = window.location.hash.replace('#/', '');
    return hashPath === '' ? 'profile' : hashPath;
  }


  private tokenExpired(token) {
    let cookieExpiredTime = JSON.parse(token)
    return new Date(cookieExpiredTime[environment.tokenExpireTime]).getTime() < new Date().getTime();
  }

  private setCookies(user: any[]): void {
    const partyId = localStorage.getEncryptedItem('partyID');
    const companyDetails = user[0].companyDetails || [];
    const company = companyDetails.find(item => item.partyid == partyId);
    const companyName = company ? company.companyname : '';

    const userInfo = {
      userName: user[0].username,
      companyName: companyName
    };

    const encryptedUserInfoKey = this.commonservice.encrypt(environment.userInfo);
    const encryptedUserInfoValue = this.commonservice.encrypt(JSON.stringify(userInfo));
    const permissions = String(user[0].permissions.Allow);
    const encryptedPermissions = this.commonservice.encrypt(permissions);

    this.commonservice.setCookie(encryptedUserInfoKey, encryptedUserInfoValue, 10000, environment.cookieDomain, '/');
    this.commonservice.setCookie(environment.permissions, encryptedPermissions, 10000, environment.cookieDomain, '/');
  }

  
}
